import app from 'flarum/common/app';
export const INSTANCES_SETTING = 'moderndesktop-oauth-forgejo.instances';
export const DEFAULT_ICON = 'fas fa-code-branch';
export const SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{0,31}$/;
export function parseInstances(json) {
  let decoded;
  try {
    decoded = JSON.parse(json || '[]');
  } catch {
    return [];
  }
  if (!Array.isArray(decoded)) return [];
  return decoded.filter(entry => !!entry && typeof entry === 'object').filter(entry => typeof entry.slug === 'string' && typeof entry.label === 'string' && typeof entry.url === 'string').map(entry => ({
    slug: entry.slug,
    label: entry.label,
    url: entry.url,
    icon: typeof entry.icon === 'string' && entry.icon ? entry.icon : DEFAULT_ICON
  }));
}
export function providerName(slug) {
  return `forgejo-${slug}`;
}
export function redirectUri(slug) {
  return `${app.forum.attribute('baseUrl')}/auth/${providerName(slug)}`;
}
export function applicationsUrl(url) {
  return `${url.trim().replace(/\/+$/, '')}/user/settings/applications`;
}

/**
 * Escapes text so the ICU message formatter renders it literally.
 */
export function escapeMessage(text) {
  return text.replace(/'/g, "''").replace(/[{}#<>]/g, char => `'${char}'`);
}
function rawTranslation(key) {
  const value = app.translator.translations[key];
  return typeof value === 'string' ? value : undefined;
}

/**
 * fof/oauth looks up provider display names by translation key, so each instance needs keys at runtime.
 */
export function addProviderTranslations(name, label, extra = {}) {
  const translations = {
    [`fof-oauth.forum.providers.${name}`]: escapeMessage(label),
    [`fof-oauth.lib.providers.${name}`]: escapeMessage(label),
    ...extra
  };
  const withButton = rawTranslation('fof-oauth.forum.log_in.with_button');
  if (withButton !== undefined) {
    translations[`fof-oauth.forum.log_in.with_${name}_button`] = withButton;
  }
  app.translator.addTranslations(translations);
}
export function adminProviderTranslations(instance) {
  const name = providerName(instance.slug);
  const prefix = `fof-oauth.admin.settings.providers.${name}`;
  const description = rawTranslation('moderndesktop-oauth-forgejo.admin.provider.description') ?? '';
  return {
    [`${prefix}.description`]: description.replace('{redirect}', escapeMessage(redirectUri(instance.slug))),
    [`${prefix}.client_id_label`]: rawTranslation('moderndesktop-oauth-forgejo.admin.provider.client_id_label') ?? 'Client ID',
    [`${prefix}.client_secret_label`]: rawTranslation('moderndesktop-oauth-forgejo.admin.provider.client_secret_label') ?? 'Client secret'
  };
}
flarum.reg.add('moderndesktop-oauth-forgejo', 'common/instances', { INSTANCES_SETTING: INSTANCES_SETTING,DEFAULT_ICON: DEFAULT_ICON,SLUG_PATTERN: SLUG_PATTERN,parseInstances: parseInstances,providerName: providerName,redirectUri: redirectUri,applicationsUrl: applicationsUrl,escapeMessage: escapeMessage,addProviderTranslations: addProviderTranslations,adminProviderTranslations: adminProviderTranslations, });